// Create a single tooltip once
const noStockTooltipElt = document.createElement('div');
noStockTooltipElt.className = 'no-stock-tooltip';
noStockTooltipElt.textContent = Translator.translate('item_nostock_receive_alert');
noStockTooltipElt.style.position = 'absolute';
noStockTooltipElt.style.opacity = '0';      // hidden by default
noStockTooltipElt.style.pointerEvents = 'none';
document.body.appendChild(noStockTooltipElt);

let cleanupAutoUpdate = null;

document.addEventListener('mouseover', (event) => {
    const target = event.target;

    // Check if the target is a product size label or a child of it
    const sizeLabel = target.classList.contains('product-size-label')
        ? target
        : target.closest('.product-size-label');

    if (!sizeLabel || !sizeLabel.hasAttribute('has-alert')) {
        return;
    }

    const { computePosition, offset, flip, shift, autoUpdate } = window.FloatingUIDOM;

    // Clean up any previous autoUpdate
    if (cleanupAutoUpdate) {
        cleanupAutoUpdate();
        cleanupAutoUpdate = null;
    }

    // Start following this sizeLabel
    cleanupAutoUpdate = autoUpdate(sizeLabel, noStockTooltipElt, () => {
        computePosition(sizeLabel, noStockTooltipElt, {
            placement: 'top',
            middleware: [offset(8), flip(), shift({ padding: 5 })],
        }).then(({ x, y }) => {
            Object.assign(noStockTooltipElt.style, {
                opacity: '1',
                left: `${x}px`,
                top: `${y}px`,
            });
        });
    });

    // Hide/stop when pointer leaves that label
    const hide = (leaveEvent) => {
        // Ignore internal moves (e.g. from label to its child)
        if (sizeLabel.contains(leaveEvent.relatedTarget)) return;

        noStockTooltipElt.style.opacity = '0';

        if (cleanupAutoUpdate) {
            cleanupAutoUpdate();
            cleanupAutoUpdate = null;
        }

        sizeLabel.removeEventListener('mouseout', hide);
    };

    sizeLabel.addEventListener('mouseout', hide);
});
